module.exports = __webpack_public_path__ + "img/recom_bg_4.45aff22a.png";